import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormModal } from './FormModal';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WhitepaperForm = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    organization: '',
    role: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/forms/whitepaper`, formData);
      if (response.data.success) {
        // Trigger PDF download
        const link = document.createElement('a');
        link.href = `${API}/download/whitepaper`;
        link.download = 'SAFE_Governance_Whitepaper_March_2026.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success('Whitepaper download started', {
          description: 'Your download should begin automatically. Thank you for your interest.'
        });
        onClose();
        setFormData({
          full_name: '',
          email: '',
          organization: '',
          role: ''
        });
        const next = window.location.pathname + window.location.search;
        navigate(`/support?source=whitepaper&next=${encodeURIComponent(next)}`);
      }
    } catch (error) {
      toast.error('Submission Failed', {
        description: 'Please try again later.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormModal isOpen={isOpen} onClose={onClose} title="Download Governance Whitepaper">
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="whitepaper-form">
        <p className="text-sm text-slate-600 mb-6">
          Enter your details to download the SAFE Governance Whitepaper (PDF). Your download will begin immediately.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Full Name *</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="whitepaper-input-name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="input-institutional"
              data-testid="whitepaper-input-email"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Organization</label>
            <input
              type="text"
              name="organization"
              value={formData.organization}
              onChange={handleChange}
              className="input-institutional"
              data-testid="whitepaper-input-org"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">Role</label>
            <input
              type="text"
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="input-institutional"
              data-testid="whitepaper-input-role"
            />
          </div>
        </div>

        <div className="flex gap-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="btn-secondary flex-1"
            data-testid="whitepaper-btn-cancel"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="btn-primary flex-1 disabled:opacity-50"
            data-testid="whitepaper-btn-submit"
          >
            {isSubmitting ? 'Submitting...' : 'Download Whitepaper'}
          </button>
        </div>
      </form>
    </FormModal>
  );
};
